module.exports = __webpack_public_path__ + "static/partner3-42ec3a7879f144898308b2f5d9fafd0e.png";